module.exports = __webpack_public_path__ + "img/emoji_dangao.ef0aa4e5.png";